export default __webpack_public_path__ + "static/wellBeingThroughTrees-ecfc060c3650b29d30f74fc66a209a00.webp";